var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
var FOOTER_BUTTONS_TYPES;
(function (FOOTER_BUTTONS_TYPES) {
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["KONW"] = 0] = "KONW";
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["CONFIRM"] = 1] = "CONFIRM";
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["CONFIRM_AUDIT"] = 2] = "CONFIRM_AUDIT";
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["CONFIRM_CANCLE"] = 3] = "CONFIRM_CANCLE";
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["CONFIRM_DELIVERY"] = 4] = "CONFIRM_DELIVERY";
    FOOTER_BUTTONS_TYPES[FOOTER_BUTTONS_TYPES["CONFIRM_DELIVERY_NOTICE"] = 5] = "CONFIRM_DELIVERY_NOTICE";
})(FOOTER_BUTTONS_TYPES || (FOOTER_BUTTONS_TYPES = {}));
var ArtMsglist = (function (_super) {
    __extends(ArtMsglist, _super);
    function ArtMsglist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.confirm = 0;
        _this.footerBtns = [];
        _this.txtColor = "";
        return _this;
    }
    ArtMsglist.prototype.created = function () {
        if (this.msgData && this.msgData.length > 0) {
            this.confirm = this.msgData[0].confirm;
            if (this.confirm == FOOTER_BUTTONS_TYPES.CONFIRM) {
                this.footerBtns = [
                    { name: '否', value: 0 },
                    { name: '是', value: 1 }
                ];
            }
            else if (this.confirm == FOOTER_BUTTONS_TYPES.KONW) {
                this.footerBtns = [
                    { name: '知道了', value: 0 }
                ];
            }
            else if (this.confirm == FOOTER_BUTTONS_TYPES.CONFIRM_AUDIT) {
                this.footerBtns = [
                    { name: '取消审核', value: -1 },
                    { name: '否', value: 0 },
                    { name: '是', value: 1 }
                ];
            }
            else if (this.type == FOOTER_BUTTONS_TYPES.CONFIRM_CANCLE) {
                this.footerBtns = [
                    { name: '取消', value: 0 },
                    { name: '确定', value: 1 }
                ];
            }
            else if (this.confirm == FOOTER_BUTTONS_TYPES.CONFIRM_DELIVERY) {
                this.footerBtns = [
                    { name: '暂不发货', value: 0, class: 'btn' },
                    { name: '继续发货', value: 1 }
                ];
            }
            else if (this.confirm == FOOTER_BUTTONS_TYPES.CONFIRM_DELIVERY_NOTICE) {
                this.footerBtns = [
                    { name: '暂不发货', value: 0, class: 'btn' },
                ];
            }
            else {
                this.footerBtns = [
                    { name: '知道了', value: 0 }
                ];
            }
        }
    };
    ArtMsglist.prototype.close = function () {
        this.$closeDialog();
    };
    ArtMsglist.prototype.footerBtnClick = function (item) {
        if (this.confirm == FOOTER_BUTTONS_TYPES.CONFIRM_AUDIT) {
            if (item.value == 0 || item.value == 1) {
                this.$emit('artMsglist:ok', item.value);
                this.close();
            }
            else {
                this.close();
            }
        }
        else {
            if (item.value == 0) {
                this.close();
            }
            else if (item.value == 1) {
                this.$emit('artMsglist:ok', item.value);
                this.close();
            }
            else {
                this.close();
            }
        }
    };
    ArtMsglist = __decorate([
        Component
    ], ArtMsglist);
    return ArtMsglist;
}(VueDialog));
export default ArtMsglist;
